module.exports = __webpack_public_path__ + "static/media/Marjorie.45855e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/Marjorie.png
// module id = 1425
// module chunks = 0